export enum MediaSetLayout {
    carousel = "carousel",
    grid = "grid",
}
